export const ASSISTANT_NAME = "Peter";

/** Sunil — portfolio owner photo */
export const PORTFOLIO_OWNER_AVATAR = "/images/profile/profile-pic7.png";

/** AI chat avatar (same as original portfolio photo) */
export const ASSISTANT_AVATAR = PORTFOLIO_OWNER_AVATAR;

export const ASSISTANT_GREETING = `Hi! I'm ${ASSISTANT_NAME}. How can I help you today?`;

/** Shared prompts — home section + /ai-assistant quick chips */
export const AI_SUGGESTED_QUESTIONS = [
   {
      id: "projects",
      text: "Tell me about Sunil's projects",
      description: "Projects he has built and shipped.",
      homeIcon: "💼",
      chipIcon: "briefcase",
      color: "pink",
   },
   {
      id: "tech",
      text: "What technologies does Sunil use?",
      description: "Tools and tech he uses.",
      homeIcon: "</>",
      chipIcon: "code",
      color: "purple",
   },
   {
      id: "experience",
      text: "What is Sunil's experience?",
      description: "his career path and milestones.",
      homeIcon: "JS",
      chipIcon: "person",
      color: "green",
   },
   {
      id: "strengths",
      text: "What are Sunil's strengths?",
      description: "What makes him stand out.",
      homeIcon: "✦",
      chipIcon: "star",
      color: "orange",
   },
];
